import { EpNodeDetail } from '@bumble/app/__generated__/data-contracts';
import DataTableGrid from '@bumble/app/components/DataTableGrid';
import { Loading } from '@bumble/app/components/Loading';
import NoData from '@bumble/app/components/NoData';
import { GridColDef } from '@mui/x-data-grid';

const columns: GridColDef[] = [
  {
    field: 'ep_name',
    headerName: 'Endpoint Name',
    flex: 1,
    minWidth: 200,
    disableColumnMenu: true,
  },
  {
    field: 'ep_id',
    headerName: 'Endpoint ID',
    width: 200,
    disableColumnMenu: true,
  },
  {
    field: 'account_id',
    headerName: 'Endpoint Owner Account',
    width: 200,
    disableColumnMenu: true,
  },
  // {
  //   field: 'type',
  //   headerName: 'Type',
  //   width: 200,
  //   align: 'right',
  //   disableColumnMenu: true,
  // },
];

const columnVisible = {
  ep_name: true,
  ep_id: true,
  account_id: true,
};

export const EndpointNodeTabEndpoint = ({
  data,
  loading,
}: {
  data: EpNodeDetail | undefined;
  loading: boolean;
}) => {
  if (loading) return <Loading />;
  if (data === undefined) return <NoData />;

  return (
    <DataTableGrid
      rows={
        data?.endpoints.map((item) => {
          return {
            ...item,
            id: item.ep_id,
          };
        }) || []
      }
      columns={columns}
      columnVisibilityModel={columnVisible}
    />
  );
};
